import { InputLabel, Modal, Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import UPButton from 'components/button';
import { ReactComponent as ChatIcon } from '../../assets/icons/ChatIcon.svg';
import { ReactComponent as ContractIcon } from '../../assets/icons/ContractIcon.svg';
import { ReactComponent as AddVendorSlotIcon } from '../../assets/icons/AddVendorSlotIcon.svg';

export const GridContainer = styled(Box)(() => ({
  width: '100%',
  paddingBottom: '16px',
}));

export const Header = styled(Box)(() => ({
  height: '80px',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
  borderRadius: '8px',
  border: 'none',
  background: 'white',
}));

export const HeaderCell = styled(Box, {
  shouldForwardProp: prop => prop !== 'highlight',
})<{ highlight?: boolean }>(({ theme, highlight }) => ({
  backgroundColor: 'white',
  ...(highlight && { background: theme.palette.primary.dark }),
  height: '64px',
  width: '194px',
  borderRadius: '8px',
  color: theme.palette.secondary.contrastText,
  padding: 10,
  margin: '0px 8px',
}));

export const DayOfWeek = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  color: theme.palette.secondary.contrastText,
  '.MuiTypography-root': {
    fontSize: '14px',
    lineHeight: '20px',
  },
  '.MuiCheckbox-root': {
    padding: 0,
  },
}));

export const NumberOfItems = styled(Box)(() => ({
  width: '32px',
  height: ' 20px',
  background: '#71B790',
  borderRadius: '16px',
  color: 'white',
  textAlign: 'center',
  fontSize: '12px',
  lineHeight: '20px',
}));

export const GridCardStyled = styled(Box, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'hover' && prop !== 'confirmed',
})<{ active?: boolean; hover?: boolean; confirmed?: boolean }>(({ theme, active, hover, confirmed }) => {
  let backgroundColor = theme.palette.info.main;
  if (active) {
    backgroundColor = 'white';
  } else if (confirmed) {
    backgroundColor = theme.palette.primary.dark;
  }
  return {
    background: backgroundColor,
    ...(active ? { border: '1px solid #DBEDE3' } : { border: '1px solid #FAFAFA' }),
    opacity: hover ? 0.5 : 1,
    borderRadius: '8px',
    padding: '8px 8px',
  };
});

export const ContractHours = styled(Box, {
  shouldForwardProp: prop => prop !== 'error',
})<{ error?: boolean }>(({ theme, error }) => ({
  fontWeight: 'bold',
  fontSize: '14px',
  lineHeight: '20px',
  color: error ? theme.palette.error.main : theme.palette.primary.main,
  display: 'flex',
}));

export const EmployeeData = styled(Box)(() => ({
  fontSize: '14px',
  lineHeight: '20px',
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  flexDirection: 'row',
  margin: '10px 0px',
  height: '68px',
}));

export const EmployeeName = styled(Box, {
  shouldForwardProp: prop => prop !== 'active',
})<{ active?: boolean; textLength: number }>(({ theme, active, textLength }) => ({
  fontSize: textLength < 14 ? '14px' : '12px',
  paddingLeft: '10px',
  color: active ? theme.palette.secondary.contrastText : theme.palette.secondary.main,
  fontWeight: 'bold',
}));

export const EmployeeRole = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  paddingLeft: '10px',
  color: theme.palette.secondary.main,
}));

export const GridColumn = styled(Box)(() => ({
  minWidth: '210px',
}));

export const AddNewContractButton = styled(UPButton)(() => ({
  margin: '16px 16px 16px 0px',
  pointerEvents: 'auto',
  height: '48px',
}));

export const CardsDivider = styled(Box)(({ theme }) => ({
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: '50px',
  minWidth: '172px',
  marginBottom: '8px',
}));

export const CardOptions = styled(Box)(() => ({
  background: 'rgba(219, 237, 227, 0.5)',
  position: 'absolute',
  top: 0,
  left: 0,
  width: 'calc(100% - 16px)',
  height: 'calc(100% - 16px)',
  marginTop: '8px',
  marginLeft: '8px',
}));

export const PasteHereCardStyled = styled(Box)(() => ({
  background: 'rgba(219, 237, 227, 0.5)',
  border: `2px dotted`,
  borderColor: '#94C8AB',
  width: '190px',
  minHeight: '80px',
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '10px',
  cursor: 'pointer',
}));

export const PasteHereText = styled(Box)(() => ({
  color: '#94C8AB',
}));

export const CardActions = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
}));

export const DimonaRefreshContainer = styled(Box)(() => ({
  marginLeft: '130px',
  marginTop: '60px',
  position: 'absolute',
}));

export const ClickableBox = styled(Box)(() => ({
  cursor: 'pointer',
}));

export const IconWithMargin = styled(Box)(() => ({
  marginLeft: '8px',
  cursor: 'pointer',
}));

export const WeeklyIcon = styled(Box)(() => ({
  position: 'relative',
  top: '10px',
  left: '-30px',
}));

export const ConfirmDateDropdownContainer = styled(Box)(() => ({
  marginRight: '15px',
  width: '50%',
}));

export const DateAndNoShowContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '33%',
  [theme.breakpoints.down(768)]: {
    width: '100%',
  },
}));

export const ConfirmHoursContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '66%',
  [theme.breakpoints.down(768)]: {
    width: '100%',
    flexWrap: 'wrap',
  },
}));

export const DayPickerError = styled(InputLabel)(({ theme }) => ({
  fontSize: 12,
  '&.MuiFormLabel-colorPrimary': {
    color: theme.palette.error.main,
  },
}));

export const ConfirmHourDateContainer = styled(Box)(({ theme }) => ({
  marginRight: '15px',
  minWidth: '93px',
  width: '100%',
  [theme.breakpoints.down(768)]: {
    marginRight: 'unset',
    padding: '10px',
    minWidth: 'unset',
    width: '100%',
  },
}));

export const EndWorkContainer = styled(Box)(({ theme }) => ({
  minWidth: '93px',
  width: 1 / 6,
  marginRight: '0px',
  [theme.breakpoints.down(768)]: {
    marginRight: 'unset',
    padding: '10px',
    minWidth: 'unset',
    width: '50%',
  },
}));

export const CompanyUserFilter = styled(Box)(() => ({
  width: '136px',
  display: 'inline-block',
  marginLeft: '8px',
}));

export const NoShowBox = styled(Box)(() => ({
  display: 'flex',
  paddingTop: '10px',
  width: 1 / 2,
}));

export const RowContainerForNoShow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '24px',
  [theme.breakpoints.down(768)]: {
    flexDirection: 'column',
  },
}));

export const ModalHeaderContract = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  background: 'white',
  zIndex: 999,
  borderTopRightRadius: '8px',
  borderTopLeftRadius: '8px',
  padding: '20px 32px',
  [theme.breakpoints.down(768)]: {
    padding: '5px',
    position: 'unset',
  },
}));

export const ModalTitleContainer = styled(Box)(() => ({
  display: 'flex',
}));

export const NameInputStyled = styled(Box)(({ theme }) => ({
  minWidth: '280px',
  display: 'inline-block',
  marginRight: '20px',
  width: '50%',
  [theme.breakpoints.down(768)]: {
    minWidth: 'unset',
    width: '100%',
    paddingBottom: '10px',
    marginRight: 'unset',
  },
}));

export const ContractTypeInputStyled = styled(Box)(({ theme }) => ({
  display: 'inline-block',
  width: '50%',
  [theme.breakpoints.down(768)]: {
    width: '100%',
  },
}));

export const ContentContainerContracts = styled(Box)(({ theme }) => ({
  overflowY: 'scroll',
  background: 'rgb(250, 250, 250)',
  display: 'flex',
  flexDirection: 'column',
  padding: '32px',
  paddingTop: '0px',
  paddingRight: '0px',
  height: 'auto',
  [theme.breakpoints.down(768)]: {
    padding: '5px',
    overflowY: 'auto',
  },
}));

export const ContractDateContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  [theme.breakpoints.down(768)]: {
    flexWrap: 'wrap',
  },
}));

export const ContractXIcon = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  display: 'flex',
  alignSelf: 'flex-start',
  paddingTop: '53px',
  [theme.breakpoints.down(768)]: {
    paddingTop: '10px',
  },
}));

export const DeleteCostDeclarationButton = styled(Box)(() => ({
  cursor: 'pointer',
  display: 'flex',
  width: 'auto',
  paddingTop: '20px',
  alignItems: 'center',
}));

export const ContractsBottomPartInputStyled = styled(Box)(({ theme }) => ({
  minWidth: '280px',
  display: 'inline-block',
  marginRight: '20px',
  width: '33.3333%',
  [theme.breakpoints.down(768)]: {
    minWidth: 'unset',
    width: '100%',
    marginRight: 'unset',
    paddingTop: '10px',
  },
}));

export const ConstCenterStyled = styled(Box)(({ theme }) => ({
  minWidth: '280px',
  display: 'inline-block',
  marginRight: '20px',
  width: '33.3333%',
  [theme.breakpoints.down(1500)]: {
    minWidth: '246px',
  },
  [theme.breakpoints.down(768)]: {
    minWidth: 'unset',
    width: '100%',
    marginRight: 'unset',
    paddingTop: '10px',
  },
}));

export const CompanyBranchInputStyled = styled(Box)(({ theme }) => ({
  minWidth: '280px',
  display: 'inline-block',
  marginRight: '20px',
  width: '66.6667%',
  [theme.breakpoints.down(768)]: {
    minWidth: 'unset',
    width: '100%',
    marginRight: 'unset',
    paddingTop: '10px',
  },
}));

export const WageStyled = styled(Box)(({ theme }) => ({
  display: 'inline-block',
  marginRight: '20px',
  width: '33.3333%',
  [theme.breakpoints.down(768)]: {
    width: '100%',
    marginRight: 'unset',
    paddingTop: '10px',
  },
}));

export const ConfirmServiceActionContainer = styled(Box)<{ hidden?: boolean }>(({ theme, hidden }) => ({
  display: hidden ? 'none' : 'block',
  cursor: 'pointer',
}));

export const CompanyLocationStyled = styled(Box)(({ theme }) => ({
  minWidth: '280px',
  display: 'inline-block',
  marginRight: '20px',
  width: '50%',

  [theme.breakpoints.down(768)]: {
    width: '100%',
    marginRight: 'unset',
    paddingTop: '10px',
  },
}));

export const WorkingLocationStyled = styled(Box)(({ theme }) => ({
  display: 'inline-block',
  marginRight: '20px',
  width: '66.6667%',

  [theme.breakpoints.down(768)]: {
    width: '100%',
    marginRight: 'unset',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
}));

export const ModalCloseIconStyled = styled(Box)(({ theme }) => ({
  position: 'absolute',
  right: 32,
  top: 32,
  width: 24,
  height: 24,
  cursor: 'pointer',

  [theme.breakpoints.down(768)]: {
    position: 'unset',
    margin: '0 0 0 auto',
  },
}));

export const NoShowModalStyled = styled(Modal)(({ theme }) => ({
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '550px',
  maxHeight: '500px',
  height: 'auto',
  '.MuiBackdrop-root': {
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
    position: 'relative',
  },
  [theme.breakpoints.up('sm')]: {
    width: '550px',
  },

  [theme.breakpoints.down(611)]: {
    width: '90%',
  },
}));

export const NoShowModalTitle = styled(Typography)(({ theme }) => ({
  marginBottom: '16px',
  color: theme.palette.secondary.contrastText,
  fontWeight: 600,
  fontSize: 16,
}));

export const StyledContractIcon = styled(ContractIcon)(({ theme }) => ({
  fill: 'white',
  'button:hover &': {
    fill: theme.palette.primary.main,
  },
}));

export const StyledAddVendorSlotIcon = styled(AddVendorSlotIcon)(({ theme }) => ({
  fill: 'white',
  'button:hover &': {
    fill: theme.palette.primary.main,
  },
}));

export const StyledChatIcon = styled(ChatIcon)(({ theme }) => ({
  fill: 'white',
  'button:hover &': {
    fill: theme.palette.primary.main,
  },
}));
